import { useEffect } from 'react';
import type { ReactNode } from 'react';

import { initAnalytics } from '@/shared/lib';

import { TelegramProvider } from './TelegramProvider';

interface AppProvidersProps {
  children: ReactNode;
}

export function AppProviders({ children }: AppProvidersProps) {
  // Инициализация до роутера: сам клиент аналитики игрока не знает
  // и без ключа ничего не делает, поэтому ждать входа незачем
  useEffect(() => {
    // Адрес приходит рантаймом, поэтому инициализация асинхронна.
    // Ждать её незачем: события до готовности клиента просто теряются,
    // а это первые полсекунды загрузки
    void initAnalytics();
  }, []);

  return <TelegramProvider>{children}</TelegramProvider>;
}
